export default class GoogleMap {

    constructor($main) {
        this.$main = $main;
        if (this.testGoogle()) {
            this.map = this.initMap();
            let options = $main.attr("data-map-options");
            options = JSON.parse(options);


            var icon = {
                path: $("symbol#fk-pin").find("path").first().attr("d"),
                fillColor: "none",
                fillOpacity: .0,
                anchor: new google.maps.Point(15, 50),
                strokeWeight: 1,
                strokeColor: "#ffffff",
                scale: 1
            };


            if (options.lat && options.lng) {
                this.map.setCenter({lat: Number(options.lat), lng: Number(options.lng)});

                let marker = new google.maps.Marker({
                    position: this.map.getCenter(),
                    icon: icon,
                    map: this.map,
                });
            }
            if (options.zoom) {
                this.map.setZoom(Number(options.zoom));
            }
        }

    }

    /**
     * Test si on a bien chargé la lib google
     * @returns {boolean}
     */
    testGoogle() {
        let r=false;
        try {
            r= typeof google !== "undefined"
        } catch (e) {
            r= false;
        }
        if(!r){
            console.warn("pas d'Internet pas de Google...pas de bras pas de chocolat");
        }
        return r;
    }

    /**
     *
     * @returns {google.maps.Map}
     */
    initMap() {
        // Create a map object and specify the DOM element for display.
        if (this.testGoogle()) {
            let map = new google.maps.Map(this.$main[0], {
                center: {lat: -34.397, lng: 150.644},
                zoom: 8,
                zoomControl: true,
                mapTypeControl: false,
                scaleControl: false,
                streetViewControl: false,
                rotateControl: false,
                fullscreenControl: true,
                scrollwheel: false,
            });
            map.setOptions({styles: GoogleMap.style});
            return map;
        }
    }


    /**
     * initialise tous les [data-google-map]
     */
    static initFromDom() {
        $("[data-google-map='']").each(function () {
            new GoogleMap($(this));
            $(this).attr("data-google-map", "initdone");
        })
    }
}


GoogleMap.style = [
    {
        "featureType": "all",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "saturation": 36
            },
            {
                "color": "#000000"
            },
            {
                "lightness": 40
            }
        ]
    },
    {
        "featureType": "all",
        "elementType": "labels.text.stroke",
        "stylers": [
            {
                "visibility": "on"
            },
            {
                "color": "#000000"
            },
            {
                "lightness": 16
            }
        ]
    },
    {
        "featureType": "all",
        "elementType": "labels.icon",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "administrative",
        "elementType": "geometry.fill",
        "stylers": [
            {
                "color": "#000000"
            },
            {
                "lightness": 20
            }
        ]
    },
    {
        "featureType": "administrative",
        "elementType": "geometry.stroke",
        "stylers": [
            {
                "color": "#000000"
            },
            {
                "lightness": 17
            },
            {
                "weight": 1.2
            }
        ]
    },
    {
        "featureType": "landscape",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#000000"
            },
            {
                "lightness": 20
            }
        ]
    },
    {
        "featureType": "poi",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#000000"
            },
            {
                "lightness": 21
            }
        ]
    },
    {
        "featureType": "road.highway",
        "elementType": "geometry.fill",
        "stylers": [
            {
                "color": "#000000"
            },
            {
                "lightness": 17
            }
        ]
    },
    {
        "featureType": "road.highway",
        "elementType": "geometry.stroke",
        "stylers": [
            {
                "color": "#000000"
            },
            {
                "lightness": 29
            },
            {
                "weight": 0.2
            }
        ]
    },
    {
        "featureType": "road.arterial",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#000000"
            },
            {
                "lightness": 18
            }
        ]
    },
    {
        "featureType": "road.local",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#000000"
            },
            {
                "lightness": 16
            }
        ]
    },
    {
        "featureType": "transit",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#000000"
            },
            {
                "lightness": 19
            }
        ]
    },
    {
        "featureType": "water",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#000000"
            },
            {
                "lightness": 17
            }
        ]
    }
];


// WEBPACK FOOTER //
// ./fk.app/_src/plugins-relay/GoogleMap.js